// extracted by mini-css-extract-plugin
export default {"form":"AddEventModal_form__BqRQk","input":"AddEventModal_input__RFBHF","label":"AddEventModal_label__RCsVq","btn":"AddEventModal_btn__Qn8Qb","btn2":"AddEventModal_btn2__YGLz7"};